import { useContext, type ReactElement } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { ODSButton, ODSGroup } from 'bc-ods';

import { FormStepEnum, SmartLoginActionsContext } from './context/SmartLoginContextProvider';

const messages = defineMessages({
  welcome: {
    id: 'SSOChooseLinkOrRegister.welcome',
    defaultMessage: 'Welcome',
  },
  noMatchingAccountFound: {
    id: 'SSOChooseLinkOrRegister.noMatchingAccountFound',
    defaultMessage:
      "We couldn't find an account matching your email. Do you have an existing Onebrief account you'd like to link, or would you like to start fresh?",
  },
  haveExistingAccount: {
    id: 'SSOChooseLinkOrRegister.haveExistingAccount',
    defaultMessage: 'I have an existing account',
  },
  createNewAccount: {
    id: 'SSOChooseLinkOrRegister.createNewAccount',
    defaultMessage: 'Create a new account',
  },
});

function SSOChooseLinkOrRegister(): ReactElement {
  const { setFormStep } = useContext(SmartLoginActionsContext);
  return (
    <ODSGroup stacked>
      <div>
        <h5>
          <FormattedMessage {...messages.welcome} />
        </h5>
        <p className="text-secondary">
          <FormattedMessage {...messages.noMatchingAccountFound} />
        </p>
      </div>
      <ODSButton
        cta
        fullWidth
        onClick={() => setFormStep(FormStepEnum.SSOLinkAccount)}
        data-testid="button-link-existing-account"
      >
        <FormattedMessage {...messages.haveExistingAccount} />
      </ODSButton>
      <ODSButton
        quiet
        fullWidth
        onClick={() => setFormStep(FormStepEnum.Register)}
        data-testid="button-create-new-account"
        css={(theme) => ({ color: theme.colors.primary, textDecoration: 'underline' })}
      >
        <FormattedMessage {...messages.createNewAccount} />
      </ODSButton>
    </ODSGroup>
  );
}

export default SSOChooseLinkOrRegister;
